<template>
   <div class="footer-but">
				<ul class="clearfix">
					<li :class="active === 1 ? 'active' : ''">
            <router-link :to="'/home?shopAlias='+$route.query.shopAlias">
							<span>
                <img class="hide" src="../images/footer/icon1.png" alt="">
                <img class="show" src="../images/footer/icon1_1.png" alt="">
              </span>
							<p>首页</p>
						</router-link>
					</li>
					<li :class="active === 2 ? 'active' : ''">
						<router-link :to="'/cell?shopAlias='+$route.query.shopAlias">
							<span>
                <img class="hide" src="../images/footer/icon2.png" alt="">
                <img class="show" src="../images/footer/icon2_2.png" alt="">
              </span>
							<p>商品</p>
						</router-link>
					</li>
					<li v-if="versionStatus" :class="active === 3 ? 'active' : ''">
						<router-link :to="'/shopcard/card?shopAlias='+$route.query.shopAlias">
							<span class="inline">
                <img class="hide" src="../images/footer/icon3.png" alt="">
                <img class="show" src="../images/footer/icon3_3.png" alt="">
                <em>HOT</em>
              </span>
							<p>会员</p>
						</router-link>
					</li>
					<li :class="active === 4 ? 'active' : ''">
						<router-link :to="'/user?shopAlias='+$route.query.shopAlias">
							<span>
                <img class="hide" src="../images/footer/icon4.png" alt="">
                <img class="show" src="../images/footer/icon4_4.png" alt="">
              </span>
							<p>我的</p>
						</router-link>
					</li>
				</ul>
			</div>
			<!--
             	 v-show="shop.serviceOpen=='true'"
             -->
			<!--<div class="fr yellow">
				<router-link :to="'/cell?shopAlias='+$route.query.shopAlias">
					<span>在线下单</span>
				</router-link>
			</div>-->

			<!-- <div class="fr">
				<div @click="gotoqcode(shop.qcodeAlias)" :to="'/qcode/'+shop.qcodeAlias">
					<span>去买单</span>
				</div>
			</div> -->
</template>

<script>
import api from '@/fetch/api'
export default {
  name: 'user',
  data () {
    return {
    }
  },
  created() {
    this.shopMenueResource(); //获取店铺服务套餐的权限信息
  },
  methods: {

  },
  props:{
    active:''
  },
  watch:{
    'active': function(val) {
        this.active = val
          }
      }
}
</script>

<style>

</style>




// WEBPACK FOOTER //
// src/components/footer.vue